import { get } from 'lodash-es';
import { UNHOSTED_PARTNER_CODES } from 'client/constants/unhosted-partner-codes';

/**
 * Checks inventory partnerCode.
 * @param {Object} inventory Inventory data.
 * @returns {Boolean} if inventory is unhosted.
 */
export const isUnhostedInventory = inventory => {
  const partnerCode = get(inventory, 'dealerInfo.partnerCode', '');
  return get(UNHOSTED_PARTNER_CODES, partnerCode, false);
};
